import * as React from 'react';

export function DataManagerIndex(): JSX.Element {
    return (
        <div className="ma-2 flex-fill">
            <h2 className="white-text">Data Manager</h2>
        </div>
    );
}
